var error = {
  translation: {
    error: {
      coreNotFound: 'Ne udalos zagruzit osnovnye nastroyki',
      domainNotAllowed: 'Регистрация с этим доменом запрещена',
      emailAlreadyInUse: 'Email занят',
      insufficientPermissions: 'Недостаточно прав',
      invalidCurrentPassword: 'Неверный текущий пароль',
      invalidPermissions: 'Пожалуйста, выберите хотя бы одно разрешение',
      invalidUsernameOrPassword: 'Nevernoe imya polzovatelya ili parol',
      localRegistrationDisabled: 'Lokalnaya registraciya otklyuchena administratorom',
      noInternetConnection: 'Net podklyucheniya k internetu',
      noOidcProfileFound: 'Профиль OIDC не найден',
      policyNotAccepted: 'Primiite Usloviya ispolzovaniya i Politiku konfidencialnosti',
      registrationDisabled: 'Registraciya polzovateley otklyuchena administratorom',
      serverConnectionFailed: 'Ne udalos podklyuchitsya k serveru',
      ssoRegistrationDisabled: 'SSO-registraciya otklyuchena administratorom',
      tooManyFailedAttempts: 'Слишком много неудачных попыток - попробуйте позже',
      unknownError: 'Neznaya oshibka, poprobuyte pozzhe',
      usernameAlreadyInUse: 'Имя занято',
      weakPassword: 'Слабый пароль',
    },
  },
};

export { error as default };
